import {get, post, url} from "../../../app/services/Backend/HttpRequest"

export default {

  fetchCompanyPreview({rootState, commit}, handle){

    const input = {
      url: url(`company/${handle}`),
    }

    return get(input).then(response => {
      commit('fillCompanyPreview', response.data)
    })
  },

  loginWithPassword({commit}, payload) {

    const input = {
      url: url('login/password'),
      payload
    }

    return post(input)
      .then(response => commit('login.fill', response.data))
      .catch(error => {
        commit('login.fail')
      })
  },

  loginWithToken({commit}, payload) {

    const input = {
      url: url('login/token'),
      payload
    }

    return post(input)
      .then(response => commit('login.fill', response.data))
  },

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth/actions.js